import { FC } from "react";
import { useTranslations } from "next-intl";

import { Loader } from "components/atoms/Loader/Loader";
import { NoResults } from "components/atoms/NoResults/NoResults";
import { Spacer } from "components/organisms/Spacer/Spacer";
import { ArticleTeaser } from "components/molecules/Teaser/ArticleTeaser";

import { ArticleRecord } from "@graphql/types/graphql";
import { SearchPaginationContainer as SearchPagination } from "../SearchPaginationContainer";
import s from "./ArticlesResults.module.scss";

interface Props {
  articles: ArticleRecord[];
  loading: boolean;
  reset: () => void;
}

export const ArticlesResults: FC<Props> = ({ articles = [], loading, reset }) => {
  const t = useTranslations("search");

  if (!loading && articles.length === 0) {
    return <NoResults copy={`${t("no-results-articles")}.`} onClearClick={() => reset()} />;
  }

  return (
    <div className={s.ArticlesResults}>
      {loading && <Loader />}
      {articles.length > 0 && (
        <div className={s.Inner}>
          <Spacer size="m">
            {articles.map((article) => (
              <ArticleTeaser article={article} key={article.id} />
            ))}
          </Spacer>
          <SearchPagination />
        </div>
      )}
    </div>
  );
};
